export const addresses = {
  alphatoken:"0xE2b34D2B8Cba586aC4e3052233A460E39fF212E8"
}
